import { CommonError } from '../../types';
import { FETCH_PRICE_BOARD_FAILURE, FETCH_PRICE_BOARD_REQUEST, FETCH_PRICE_BOARD_SUCCESS, SET_CURRENT_PRICE } from './constants';
import { PriceBoard } from './types';
export interface FetchPriceBoardRequestAction {
    type: typeof FETCH_PRICE_BOARD_REQUEST;
    payload: string;
}

export interface FetchPriceBoardSuccessAction {
    type: typeof FETCH_PRICE_BOARD_SUCCESS;
    payload: PriceBoard;
}

export interface FetchPriceBoardFailureAction {
    type: typeof FETCH_PRICE_BOARD_FAILURE;
    payload: CommonError;
}
export interface SetCurrentPriceAction {
    type: typeof SET_CURRENT_PRICE;
    payload: number;
}
export type PriceBoardActions = FetchPriceBoardRequestAction | FetchPriceBoardSuccessAction | FetchPriceBoardFailureAction | SetCurrentPriceAction;

export const  fetchPriceBoardRequest = (payload: string): FetchPriceBoardRequestAction => ({
    type: FETCH_PRICE_BOARD_REQUEST,
    payload
});

export const fetchPriceBoardSuccess = (priceBoard: PriceBoard): FetchPriceBoardSuccessAction => ({
    type: FETCH_PRICE_BOARD_SUCCESS,
    payload: priceBoard,
});

export const fetchPriceBoardFailure = (error: CommonError): FetchPriceBoardFailureAction => ({
    type: FETCH_PRICE_BOARD_FAILURE,
    payload: error,
});

export const setCurrentPrice = (payload: number): SetCurrentPriceAction => ({
    type: SET_CURRENT_PRICE,
    payload,
});

